import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/pl';
import 'select2/dist/css/select2.css';

const init = () => {
  $(() => {
    $('.select2-enabled').select2({
      width: '100%',
      language: 'pl',
    });
  });
};

export default init;
